/*!
 * Usagi Split Text 2.1.2
 * @license Copyright, GardenEight. All rights reserved.
*/



export default class UsagiSplitText {

	constructor(opts = {}) {

		
		//
		this.el        = Array.isArray(opts.el) ? [...opts.el] : [opts.el];
		this.lang      = opts.lang ? opts.lang : 'en';
		this.type      = opts.type ? opts.type : 'words';
		this.delay     = opts.delay ? opts.delay : 0;
		this.charDelay = (opts.charDelay == null) ? 0 : Number(opts.charDelay);
		this.wordDelay = (opts.wordDelay == null) ? 0 : Number(opts.wordDelay);
		this.lineDelay = (opts.lineDelay == null) ? 0 : Number(opts.lineDelay);
		this.inview    = (opts.inview == null) ? true : Boolean(opts.inview);
		this.css       = (opts.css == null ) ? false : Boolean(opts.css);
		this.timing    = opts.timing === 'inview' ? true : false;

		// 日本語 x 単語の場合は文字分割を強制
		if( this.lang === 'ja' && this.type === 'words' ){
			this.type = 'chars';
		}

		//
		this.center = (opts.center == null) ? false : (this.type === 'line') ? false : opts.center;

		// Init
		if( this.inview && !this.timing ) this.onInit();
		if( this.inview ) this.onInitInview();
		this.addEvents();


	}

	onInit(){

		//
		this.targets = [];
		for (let i = 0; i < this.el.length; i++) {
			const el = this.el[i];
			const strs = this.parseHTML( el, this.lang );
			if( !el.classList.contains('is-splited') ){
				this.targets.push({
					el : this.el[i],
					strs : strs
				});
			}
			el.classList.add('is-splited');
		}

		//
		this.targets.forEach( (a) =>{
			let windex = 0;
			let cindex = 0;
			a.strs.forEach( (b,i) =>{
				b.windex = windex;
				b.cindex = cindex;
				switch( b.type ){
					case 'tag':
						b.array.forEach( (c,j) =>{
							switch( c.type ){
								case 'tag':
								case 'txt':
									c.windex = windex;
									c.cindex = cindex;
									cindex += c.char.length;
									windex += 1;
								break;
							}
						});
					break;
					case 'txt':
						cindex += b.char.length;
						windex += 1;
					break;
					default:
					break;
				}
			});
			a.wmax = windex;
			a.cmax = cindex;
		});


		//
		this.targets.forEach( (a) =>{
			a.html = '';
			a.strs.forEach( (b) =>{
				a.html += this.getHtml( a, b );
			});
			a.el.textContent = '';
			a.el.insertAdjacentHTML('afterbegin', a.html );
			switch( this.type ){
				case 'line':
					this.onInitLine( a );
				break;
				default:
					const center = (typeof a.el.dataset.splitCenter != 'undefined') ? true : this.center;
					if( center ){
						this.onInitCenter( a );
					}
				break;
			}
		});

		//
		if( this.css ) this.onInitCssAnimation();

	}

	onInitCenter( target ){

		//
		const el = target.el;
		const wrapRect = target.el.getBoundingClientRect();
		const wrapCx = wrapRect.left + wrapRect.width/2;
		const globalDelay = el.dataset.splitDelay ? Number( el.dataset.splitDelay ) : this.delay;
		const wordDelay = el.dataset.splitWordDelay ? Number( el.dataset.splitWordDelay ) : this.wordDelay;
		const charDelay = el.dataset.splitCharDelay ? Number( el.dataset.splitCharDelay ) : this.charDelay;

		//
		switch( this.type ){
			case 'chars':

				//
				const charElem = el.querySelectorAll('.js-split-c');
				const charFirstElem = charElem[0];
				const charFirstRect = charFirstElem.getBoundingClientRect();

				// おおよそ n文字 はいる
				const charMax = Math.floor( wrapRect.width/charFirstRect.width );

				//
				for (let i = 0; i < charElem.length; i++) {
					const el = charElem[i];
					const c_rect = el.getBoundingClientRect();
					const c_cx = c_rect.left + c_rect.width/2;
					const c_fx = c_cx - wrapCx;
					const c_px = Math.abs( c_fx/(wrapRect.width/2) );
					el.style.transitionDelay = c_px * ( charDelay * charMax ) + globalDelay + 's';
				}

			break;
			default:

				//
				const wordElem = el.querySelectorAll('.js-split-w');
				for (let i = 0; i < wordElem.length; i++) {
					const el = wordElem[i];
					const w_rect = el.getBoundingClientRect();
					const w_cx = w_rect.left + w_rect.width/2;
					const w_fx = w_cx - wrapCx;
					const w_px = Math.abs( w_fx/(wrapRect.width/2) );
					el.style.transitionDelay = w_px * ( wordDelay * 10 ) + globalDelay + 's';
				}

			break;
		}

	}

	onInitLine( target ){

		const el = target.el;

		//
		const o = el.querySelectorAll('.js-split-o,.js-split-s');
		const wrapRect = el.getBoundingClientRect();
		const firstRect = o[0].getBoundingClientRect();
		const maxLine = Math.floor( wrapRect.height / firstRect.height * 2 );

		//
		const line = [];
		for (let n = 0; n < maxLine; n++) {
			line.push({
				array : [],
				wrap  : document.createElement('div'),
				div   : document.createElement('div')
			});
		}

		//
		for (let n = 0; n < o.length; n++) {
			const w = o[n];
			const rect = w.getBoundingClientRect();
			const l = Math.round( (rect.top - wrapRect.top) / rect.height );
			if( line[l] ){
				line[l].array.push( w );
			}
		}

		//
		for (let n = 0; n < line.length; n++) {
			const z = line[n];
			const next = line[n+1];
			for (let m = 0; m < z.array.length; m++) {
				z.div.classList.add('js-split-l');
				z.div.style.transitionDelay = this.lineDelay * n + 's';
				z.div.appendChild( z.array[m] );
			}
			const child = z.div.querySelectorAll('.js-split-o,.js-split-s');
			if( child.length ){
				if( next && next.array.length ){
					z.wrap.classList.add('has-next-line');
					if( n === 0 ) z.wrap.classList.add('first-line');
				} else {
					z.wrap.classList.add('last-line');
				}
				z.wrap.dataset.li = n;
				z.wrap.classList.add('js-split-o');
				z.wrap.appendChild( z.div );
				el.appendChild( z.wrap );
			}
		}

	}

	getHtml( target, str ){

		const el = target.el;
		let whtml = '';
		let chtml = '';
		const globalDelay = el.dataset.splitDelay ? Number( el.dataset.splitDelay ) : this.delay;
		const wordDelay = el.dataset.splitWordDelay ? Number( el.dataset.splitWordDelay ) : this.wordDelay;
		
		//
		let wdelay = globalDelay + str.windex * wordDelay;
		if( this.lang === 'ja' && this.type === 'chars' ){
			wdelay = 0;
		}

		//
		switch( str.type ){
			case 'tag':
				let thtml = '';
				for (let i = 0; i < str.array.length; i++) {
					const v = str.array[i];
					v.wdelay = wdelay;
					chtml = this.getCharHtml( target, v );
					whtml += this.getWordHtml( target, v, chtml );
				}
				const attrs = Object.entries(str.attr).map(([key, value]) => `${key}="${value}"`).join(' ');
				thtml += `<${str.tagName} ${attrs}><span class="js-split-tag-inner">${whtml}</span></${str.tagName}>`;
				return thtml;
			break;
			default:
				str.wdelay = wdelay;
				chtml = this.getCharHtml( target, str );
				whtml = this.getWordHtml( target, str, chtml );
				return whtml;
			break;
		}

	}

	getCharHtml( target, str ){
		const el = target.el;
		const center = el.dataset.splitCenter ? true : this.center;
		let chtml = '';
		let cdelayStyle = '';
		let charDelay = el.dataset.splitCharDelay ? Number( el.dataset.splitCharDelay ) : this.charDelay;
		let cdelay = 0;
		switch( this.type ){
			case 'chars':
				if( this.lang === 'ja' ){
					const v = str.char[0];
					cdelay = Number( str.windex * charDelay );
					cdelayStyle = ( cdelay != 0 && !center ) ? `style="transition-delay:${cdelay}s"` : '';
					chtml += `<span class="js-split-c" ${cdelayStyle} data-split-char-i="${str.windex}" data-split-char="${v}">${v}</span>`;
				} else {
					for (let i = 0; i < str.char.length; i++) {
						const v = str.char[i];
						cdelay = Number( (str.cindex + i) * charDelay );
						cdelayStyle = ( cdelay != 0 && !center ) ? `style="transition-delay:${cdelay}s"` : '';
						chtml += `<span class="js-split-c" ${cdelayStyle} data-split-char-i="${str.cindex + i}" data-split-char="${v}">${v}</span>`;
					}
				}
			break;
			case 'words':
			case 'line':
				chtml = str.word;
			break;
		}

		return chtml;
	}

	getWordHtml( target, str, chtml ){
		let whtml = '';
		switch( str.type ){
			case 'hs':
			case 'zs':
				whtml = `<span class="js-split-s" data-split-type="${str.type}" >${str.word}</span>`;
			break;
			default:
				switch( this.type ){
					case 'words':
						const center = target.el.dataset.splitCenter ? true : this.center;
						const wdelayStyle = ( str.wdelay != 0 && !center ) ? `style="transition-delay:${str.wdelay}s"` : '';
						whtml = `<span class="js-split-o" data-split-type="${str.type}" data-split-word-i="${str.windex}"><span class="js-split-w" ${wdelayStyle} data-split-type="${str.type}" data-split-word="${this.htmlreplacechars(str.word)}">${chtml}</span></span>`;
					break;
					case 'chars':
						whtml = `<span class="js-split-o" data-split-type="${str.type}" data-split-word-i="${str.windex}">${chtml}</span>`;
					break;
					case 'line':
						whtml = `<span class="js-split-o" data-split-type="${str.type}" data-split-word-i="${str.windex}">${chtml}</span>`;		
					break;
				}
			break;
		}
		return whtml;
	}

	parseHTML( target, lang ) {
		const result = [];
		for (let i = 0; i < target.childNodes.length; i++) {
			result.push(...this.parseNode( target.childNodes[i], lang ));
		}
		return result;
	}

	parseNode(node, lang) {
		const result = [];
		if (node.nodeType === Node.TEXT_NODE) {
			const texts = lang === 'ja' ? Array.from(node.textContent) : node.textContent.split(/( |　)/);
			for (let i = 0; i < texts.length; i++) {
				if (texts[i]) {
					if (texts[i] === ' ') {
						result.push({
							type: 'hs',
							word: ' ',
							char: [' ']
						});
					} else if (texts[i] === '　') {
						result.push({
							type: 'zs',
							word: '　',
							char: ['　']
						});
					} else {
						result.push({
							type: 'txt',
							word: texts[i],
							char: Array.from(texts[i])
						});
					}
				}
			}
		} else if (node.nodeType === Node.ELEMENT_NODE) {
			const attrs = {};
			node.classList.add('js-split-tag');
			for (let k = 0; k < node.attributes.length; k++) {
				attrs[node.attributes[k].name] = node.attributes[k].value;
			}
			const arr = [];
			for (let i = 0; i < node.childNodes.length; i++) {
				arr.push(...this.parseNode(node.childNodes[i],lang));
			}
			result.push({
				type: 'tag',
				tagName: node.tagName.toLowerCase(),
				array: arr,
				attr: attrs
			});
		}
		return result;
	}

	onInitInview(){

		//===
		this.inview = [];

		//===
		this.el.forEach( (el,i) =>{
			this.inview.push({
				el : el,
				visible : false,
				observer : null,
				listerner : null
			});
		});

		//===
		this.inview.forEach( (v,i) =>{
			v.listerner = (changes) => {
				changes.forEach((e) => {
					const isIntersecting = e.isIntersecting;
					if ( isIntersecting ) {
						if( !v.el.dataset.shown ){
							if( this.timing ){
								this.onInit();
								setTimeout( () => { v.el.dataset.shown = 1; } , 100 );
							} else {
								v.el.dataset.shown = 1;
							}
						}
						v.el.dataset.visible = 1;
					} else {
						v.el.dataset.visible = 0;
					}
				});
			}
			v.observer = new IntersectionObserver( v.listerner, { threshold: 0 } );
			v.observer.observe( v.el );
		});
	}

	onInitCssAnimation(){
		this.css = [];

		let $t;
		for (var i = 0; i < this.el.length; i++) {
			switch( this.type ){
				case 'chars':
					$t = this.el[i].querySelectorAll('.js-split-c');
				break;
				case 'words':
					$t = this.el[i].querySelectorAll('.js-split-w');
				case 'line':
					$t = this.el[i].querySelectorAll('.js-split-l');
				break;
			}
			for (let n = 0; n < $t.length; n++) {
				const v = $t[n];
				this.css.push({
					el : v,
					start : null,
					end : null
				})
			}
		}
		this.css.forEach( (v,i) =>{
			v.start = (e) => {
				v.el.dataset.anim = 1;
			};
			v.end = (e) => {
				v.el.dataset.anim = 0;
			};
			v.el.addEventListener('transitionstart', v.start );
			v.el.addEventListener('transitionend', v.end );
		});
	}

	onDestroy(){

		//
		this.inview.forEach( (v,i) =>{
			if( v.observer ){
				v.observer.disconnect( v.el );
				v.observer = null;
			}
			if( v.listerner ) v.listerner = null;
		});
		this.inview = [];

		//
		if( this.css.length ){
			this.css.forEach( (v,i) =>{
				v.el.removeEventListener('transitionstart', v.start );
				v.el.removeEventListener('transitionend', v.end );
				v.start = null;
				v.end = null;
			});
			this.css = [];
		}

		//
		this.removeEvents();

	}

	addEvents() {
		this.onResize = this.onResize.bind(this)
		window.addEventListener('resize', this.onResize)
	}

	removeEvents() {
		window.removeEventListener('resize', this.onResize)
	}

	onResize(){
		switch( this.type ){
			case 'line':
				for (let i = 0; i < this.el.length; i++) {
					const v = this.el[i];
					const str = v.textContent;
					v.textContent = str;
					v.classList.remove('is-splited');
				}
				this.onInit();
			break;
		}
	}

	htmlreplacechars(str){
		if(typeof str !== 'string'){
			return str;
		}
		return str.replace(/[&'`"<>]/g, (match) => {
		return {
			'&' : '&amp;',
			"'" : '&#x27;',
			'`' : '&#x60;',
			'"' : '&quot;',
			'<' : '&lt;',
			'>' : '&gt;',
			"," : "&#44;"
		}[match]
		}
		);
	}

}





